var module = angular.module('octopusApp.projects');

module.controller('ProjectTriggersController', function ($scope, $stateParams, busy, pageTitle, projectState, octopusRepository, unsavedChanges) {
    var isLoading = $scope.isLoading = busy.create();
    var isSaving = $scope.isSaving = busy.create();
    var projectId = $stateParams.projectId;

    var loadTriggers = function(){
        var promises = [];

        promises.push(octopusRepository.Projects.getTriggers($scope.project));

        promises.push(octopusRepository.Events.categories({appliesTo: "Machine"}));

        promises.push(octopusRepository.Environments.all());

        promises.push(octopusRepository.Events.groups({appliesTo: "Machine"}));

        isLoading.promises(promises).then(function(results){

            var triggers = results[0];
            var eventCategories = results[1];
            var environments = results[2];
            var eventGroups = results[3];

            _.each(triggers.Items, function (trigger) {
                trigger.environment = getTags(trigger.Filter.EnvironmentIds, environments);

                var selectedEventGroups = trigger.Filter.EventGroups || [];

                var selectedEventGroupCategories = getEventCategoriesForEventGroups(selectedEventGroups, eventGroups, eventCategories);
                var selectedEventCategories = trigger.Filter.EventCategories || [];


                var allSelectedEventCategories = _.union(selectedEventGroupCategories, selectedEventCategories);

                trigger.events = getTags(allSelectedEventCategories, eventCategories);
                trigger.roles = trigger.Filter.Roles ? trigger.Filter.Roles.join(',') : [];
            });
            $scope.triggers = triggers;
        });
    };

    function getEventCategoriesForEventGroups(selectedEventGroups, allEventGroups, allEventCategories) {
        if (selectedEventGroups.length > 0) {
            var selectedGroups = _.filter(allEventGroups, function (eventGroup) {
                return selectedEventGroups.indexOf(eventGroup.Id) > -1;
            });
            var selectedEventCategoryIds = _.flatten(_.map(selectedGroups, function (selectedGroup) {
                return selectedGroup.EventCategories;
            }));
            return selectedEventCategoryIds;
        } else {
            return [];
        }
    }

    isLoading.promise(projectState.load().then(function (project) {
        isLoading.promise(octopusRepository.Projects.getChannels(project).then(function (channels) {
            isLoading.promise(projectState.deploymentProcessAsync.then(function (deploymentProcess) {
                pageTitle(project.Name + " triggers");

                $scope.project = project;
                $scope.actionsByName = {};
                $scope.deploymentProcess = deploymentProcess;

                var actions = _.chain(deploymentProcess.Steps).map(function(step){ return step.Actions; }).flatten().value();
                $scope.actionsByName = _.object(_.pluck(actions, "Name"), actions);

                // ARC-related scope variables.
                $scope.channels = channels;
                $scope.builtInFeedPackageActions = _.filter(
                _.flatten(
                    _.map(deploymentProcess.Steps,
                    function (s) {
                        return s.Actions;
                    })
                ),
                function (a) {
                    return a.Properties["Octopus.Action.Package.FeedId"] === 'feeds-builtin';
                });

                // Initialise this here so people can disable ARC and save
                $scope.showAutomaticReleaseCreation = $scope.builtInFeedPackageActions.length > 0 || project.AutoCreateRelease === true;

                loadTriggers();
            }));
        }));
    }));

    // ARC
    $scope.changeReleaseCreation = function () {
        if(!$scope.builtInFeedPackageActions) {
            $scope.project.AutoCreateRelease = false;
        }
        if(!$scope.builtInFeedPackageActions || !$scope.project.AutoCreateRelease) {
            $scope.project.ReleaseCreationStrategy.ReleaseCreationPackageStepId = null;
            $scope.project.ReleaseCreationStrategy.ChannelId = null;
        }
        if ($scope.project.AutoCreateRelease && $scope.channels.Items.length === 1) {
            $scope.project.ReleaseCreationStrategy.ChannelId = $scope.channels.Items[0].Id;
        }
        isSaving.promise(octopusRepository.Projects.modify($scope.project).then(function (p) {
            unsavedChanges.saved();
        }));
    };

    var getTags = function(selectedOptions, allOptions) {
        if (!selectedOptions || selectedOptions.length === 0 || allOptions.length === 0) {
            return "";
        }

        var result = [];
        _.each(allOptions, function (e) {
            if (_.contains(selectedOptions, e.Id)) {
                result.push(e.Name);
            }
        });
        return result.join(",");
    };
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/triggers/project_triggers_controller.js
// module id = 573
// module chunks = 1